import React from "react";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

/**
 * Aviso (amarelo), mesmo padrão visual de MensagemSucesso/MensagemErro.
 * autoHideDuration null: permanece até fechar via handleClose (ex.: fim do processamento).
 */
const MensagemAviso = ({ open, handleClose, msg }) => {
  return (
    <Snackbar open={open} autoHideDuration={null} onClose={handleClose}>
      <Alert onClose={handleClose} severity="warning">
        {msg}
      </Alert>
    </Snackbar>
  );
};

export default MensagemAviso;
